module.exports = __webpack_public_path__ + "static/media/alert.ad971786.svg";